import { LocationStrategy, PlatformLocation } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/pro-duotone-svg-icons';
import { NbToastrService } from '@nebular/theme';
import { FileUploadService } from '../../../../../../app/harvest-engine/core/services/FileUpload.service';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { SessionService } from '../../../../../@core/utils/session.service';
import { ContractService } from '../../services/contract.service';


import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContractTemplateType } from '../../../../../shared/enum';
import { PurchaseOrderService } from '../../../purchase-order/services/purchaseorder.service';

@Component({
  selector: 'popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss'],
 

})
export class PopupModalComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  row: any;
  public dropEle?: HTMLElement ;
  public isDropAreaVisible: boolean = true; 


  dropElement!: HTMLElement; // Define dropElement

  public isLoading: boolean = false;
  // public order: Order = {};
  public files: File[] = [];


  // icons
  faSave = faSave;
  faClose = faWindowClose;
  type: string = '';
  

  constructor(
    private session: SessionService,
    private matDialog: MatDialog,
   private toastrService: NbToastrService,
    // private orderService: OrdersService,
    private errorService: ErrorService,
    public uploadService: FileUploadService,
    public contractService: ContractService,
    //private toastr: NbToastrService,
    public dialogRef: MatDialogRef<PopupModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    // private location: Location
    private locationStrategy: LocationStrategy,
    private platformLocation: PlatformLocation,
    public purchaseOrderService: PurchaseOrderService
  ) { }
  public path: Object = {
    saveUrl: 'https://services.syncfusion.com/angular/production/api/FileUploader/Save',
    removeUrl: 'https://services.syncfusion.com/angular/production/api/FileUploader/Remove' };
 

  ngOnInit() {
    this.dropEle = document.getElementById('droparea2')!;
    // this.order = {...this.session.order};
    this.row = this.data.row;
    if(this.data.hasOwnProperty('type')) this.type = this.data.type;
    // 
  }
  onFileUpload(event) {
    // 
    this.files = [];
    this.files.push(...event.addedFiles);
    
  }
  onRemove(event) {
    // 
    this.files.splice(this.files.indexOf(event), 1);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.files = Array.from(input.files);
    } else {
       this.toastrService.danger('No files selected.');

    }
  }


  save(): void {
    if (!this.files || !this.files.length) {
     
      this.toastrService.danger('No file selected. Please select a file to upload.', 'Error');
      return;
      }
  
    const file = this.files[0];
    if (file.size === 0) {
      
      this.toastrService.warning('The selected file is empty. Please select a valid file.', 'Warning');

      return;
    }
  
    this.isLoading = true;
    const reader = new FileReader();
  
    reader.readAsDataURL(file);
  
    reader.onload = () => {
      const base64 = reader.result as string;
    //  console.log(base64);

    if(this.type == "POFileUpload"){
      this.purchaseOrderFileUpload();
    }else{ 
  
      this.uploadService.postContractUploads([this.files[0]], this.row.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          const contractDTO = { ...this.row, contractStatus: 'Signed', isLocked: true };

          let saveERPFlag = false;
          if(contractDTO.contractTemplateName == ContractTemplateType.SalesOfferTenPR){
            saveERPFlag = true;
          }
  
          this.contractService.putContract(contractDTO, this.row.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: () => {
              this.isLoading = false;


          this.matDialog.closeAll();
        }})
      }, error: err => { 
        this.isLoading = false;
        this.errorService.handleError(err); 
        console.error(err);
      }})
    };
  }
    // 
    // 
   
  }

  cancel() {
    // window.location.href = window.location.href;
    this.matDialog.closeAll();
  }

  onUploadSuccess(event: any): void {
    if (event?.filesData?.length) {
      this.files = event.filesData.map((file: any) => file.rawFile); 
      const invalidFiles = this.files.filter(file => file.size === 0);
      this.isDropAreaVisible = false;
      if (invalidFiles.length > 0) {
         this.toastrService.danger('One or more files have a size of 0 bytes. Please upload a valid file.');

        return;
      }
  
      //console.log('Files selected:', this.files);
      this.toastrService.danger('Files selected:');

    } else {
       this.toastrService.danger('No files selected in onUploadSuccess.');

    }
  }
  

  // Reset the visibility of the drop area if needed
  resetDropAreaVisibility(event: any) : void {
    this.isDropAreaVisible = true;
    this.files = [];
  }

  purchaseOrderFileUpload(){
    this.uploadService.postPOUploads([this.files[0]], this.row.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
      // console.log(x)
      let purchseOrderDTO = this.row
      purchseOrderDTO.status = "Signed", 
      purchseOrderDTO.isLocked = true;

      let saveERPFlag = false;
      let methodName = "";
      if(this.row.contractTemplateName != ContractTemplateType.Amendment){
        saveERPFlag = true;
        methodName = "Create";
      }
      this.purchaseOrderService.updatePO(purchseOrderDTO,saveERPFlag,methodName).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(z => {
        // console.log(z)
        this.isLoading = false;
        this.dialogRef.close(true);
        this.matDialog.closeAll();
      })
    }, error:err => { 
      this.isLoading = false;
      this.errorService.handleError(err);
    }})
  }

}
